//
import { LangComJa } from '@/locales/lang-com-ja';
export const ja = {
  com: LangComJa,
  dateLabel: '掲載日：2026年1月28日',
  title: '当社代表を装ったなりすましアカウントに関する注意喚起',
  body: `平素よりINSPIRE合同会社のWebサイトをご覧いただき、誠にありがとうございます。

現在、一部のチャット／メッセージサービス上において、当社代表を名乗る不正ななりすましアカウントが確認されております。

当該アカウントは、当社および当社代表とは一切関係のない第三者によるものであり、当社として当該アカウントの作成・利用・関与は行っておりません。

当社からの正式なご連絡は、本Webサイトに記載の連絡先、ならびに既存のお取引において、双方で確認済みの公式連絡手段のみを使用しております。

万が一、当社代表または当社関係者を名乗る不審な連絡を受信された場合は、ご対応される前に、下記お問い合わせ先までご一報いただけますと幸いです。

本件につきましては、関係サービスの運営元へ通報し、適切な対応を進めております。

今後とも、何卒ご理解とご協力のほどよろしくお願い申し上げます。`,
  requestLink: 'お問い合わせ',
};
